/* eslint-disable react/prop-types */
import React from 'react';

import setGAEvent from '../../config/firebaseConfig';

const LinkComponent = ({ url, eventName, children }) => <a href={url} target="_blank" rel="noreferrer" onClick={() => setGAEvent(eventName)}>{children}</a>;
export default LinkComponent;
